module.exports = __webpack_public_path__ + "img/audit-wizard.cfe56616.png";